<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapActions, mapGetters } from "vuex";
import { ModelListSelect } from "vue-search-select";

export default {
  page: {
    title: "Chart Of Accounts",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
  },
  data() {
    return {
      title: "Chart of Accounts",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Chart of Accounts",
          active: true,
        },
      ],
      data: {
        number: "",
        name: "",
        parent: "",
        account_type: "",
      },
      pageError: {
        classError: false,
      },
    };
  },

  computed: {
    ...mapGetters("accounts", [
      "getAccounts",
      "getChartOfAccounts",
      "SaveStatus",
    ]),
    ...mapGetters("auth", ["getCurrentUser"]),
  },
  watch: {
    // getSmsCalc() {
    // },
  },
  mounted() {},
  methods: {
    ...mapActions({
      FetchAccounts: "accounts/fetchAccounts",
      FetchChartOfAccounts: "accounts/fetchChartOfAccounts",
      AddAccount: "accounts/addAccount",
    }),

    // COMMA SEPERTOR FUNCTION
    thousandSeperater(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },

    addChartAccount() {
      this.AddAccount(this.data);
    },

    resetAddModal() {
      this.data.test = "";
      this.data.year = "";
      this.data.priority = "";
    },
    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },
  },
  created() {
    this.FetchAccounts();
    this.FetchChartOfAccounts();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div
      class="row d-flex"
      v-if="
        getCurrentUser.permissions.find((item) =>
          item.permission.includes('chart_of_accounts')
        )
      "
    >
      <div class="col-md-12 mx-auto">
        <div class="card row">
          <div class="col-12">
            <button
              v-b-modal.add-chart-modal
              class="btn btn-sm btn-primary float-end mt-2"
              v-if="
                getCurrentUser.permissions.find((item) =>
                  item.permission.includes('add_account_chart_of_accounts')
                )
              "
            >
              <i class="fa fa-plus"></i> Add New
            </button>
          </div>
          <b-modal
            id="add-chart-modal"
            hide-footer
            @hidden="resetAddModal()"
            v-if="
              getCurrentUser.permissions.find((item) =>
                item.permission.includes('add_account_chart_of_accounts')
              )
            "
          >
            <template #modal-title> Add Account Item </template>
            <form @submit.prevent="addChartAccount">
              <div class="row d-flex">
                <div class="form-group col-md-6 mb-2">
                  <label>Select Account</label>
                  <select
                    required
                    v-model="data.account_type"
                    class="form-control"
                  >
                    <option selected value="" disabled>Select Item</option>
                    <option value="ASSET">ASSET</option>
                    <option value="REVENUE">REVENUE</option>
                    <option value="EXPENSES">EXPENSES</option>
                    <option value="EQUITY">EQUITY</option>
                    <option value="LIABILITIES">LIABILITIES</option>
                  </select>
                </div>
                <div class="form-group col-md-6 mb-2">
                  <label>Number</label>
                  <div class="input-group">
                    <input
                      required
                      type="text"
                      placeholder="Account Number"
                      class="form-control"
                      v-model="data.number"
                    />
                  </div>
                </div>
                <div class="form-group col-md-6 mb-2">
                  <label>Name</label>
                  <div class="input-group">
                    <input
                      required
                      type="text"
                      placeholder="Account Name"
                      class="form-control"
                      v-model="data.name"
                    />
                  </div>
                </div>
                <div class="form-group mb-2 col-md-6">
                  <label>Account Under </label>
                  <model-list-select
                    required
                    :list="getAccounts ? getAccounts : []"
                    v-model="data.parent"
                    option-value="id"
                    option-text="acc_name"
                    class="mb-2"
                    placeholder="Select Account"
                  >
                  </model-list-select>
                </div>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-sm btn-outline-danger"
                  data-dismiss="modal"
                  @click="closeModal('add-chart-modal')"
                >
                  <i class="fa fa-times"></i> Close
                </button>
                <button
                  v-if="SaveStatus"
                  disabled
                  type="button"
                  class="btn btn-sm btn-outline-primary"
                >
                  <b-spinner
                    variant="priamry"
                    small
                    label="Spinning"
                  ></b-spinner>
                  Submitting...
                </button>
                <button
                  v-else
                  type="submit"
                  class="btn btn-sm btn-outline-primary"
                >
                  <i class="fa fa-check"></i>
                  Submit Account
                </button>
              </div>
            </form>
          </b-modal>
          <div class="card-body col-md-12 mx-auto row">
            <div class="col-12">
              <div class="col-lg-12">
                <b-card
                  class="mb-2"
                  no-body
                  v-for="(account, index) in getChartOfAccounts"
                  :key="index"
                >
                  <b-row no-gutters class="align-items-center">
                    <b-col md="12">
                      <b-card-header
                        ><h4
                          class="
                            card-title
                            mb-2
                            text-uppercase
                            font-weight-boldw
                            text-primary
                          "
                        >
                          {{ account.name }}
                        </h4></b-card-header
                      >
                      <b-card-body>
                        <div class="row">
                          <div
                            class="col-md-6"
                            v-for="(detailledAccount,
                            index1) in account.children"
                            :key="index1"
                          >
                            <dl>
                              <dt>
                                <span class="text-secondary m-1"
                                  >{{ detailledAccount.number }}
                                </span>
                                <span class="m-1">{{
                                  detailledAccount.name
                                }}</span>
                              </dt>
                              <dd
                                class="ml-2 mt-2"
                                style="margin-left: 1rem"
                                v-for="(child1,
                                index1) in detailledAccount.children"
                                :key="index1"
                              >
                                <p class="mb-1">
                                  <!-- <router-link
                                    to="/marks/filter/allmarks"
                                    class="m-1 text-secondary"
                                  > -->
                                  <span class="m-1">{{ child1.number }} </span>
                                  <span class="m-1">{{ child1.name }}</span>
                                  <!-- </router-link> -->
                                </p>
                                <dl
                                  class="mb-2"
                                  v-for="(child2, index2) in child1.children"
                                  :key="index2"
                                >
                                  <p class="text-muted m-1">
                                    <!-- <router-link
                                      to="/marks/filter/allmarks"
                                      class="m-1 text-secondary"
                                    > -->
                                    <span class="m-1"
                                      >{{ child2.number }}
                                    </span>
                                    <span class="m-1">{{ child2.name }}</span>
                                    <!-- </router-link> -->
                                  </p>
                                  <dd
                                    class="ml-2 mt-2"
                                    style="margin-left: 2rem"
                                    v-for="(child3, index2) in child2.children"
                                    :key="index2"
                                  >
                                    <p class="mb-1">
                                      <!-- <router-link
                                        to="/marks/filter/allmarks"
                                        class="ml-3 text-secondary"
                                      > -->
                                      <span class="m-1"
                                        >{{ child3.number }}
                                      </span>
                                      <span class="m-1">{{ child3.name }}</span>
                                      <!-- </router-link> -->
                                    </p>
                                  </dd>
                                </dl>
                              </dd>
                            </dl>
                          </div>
                        </div>
                      </b-card-body>
                    </b-col>
                  </b-row>
                </b-card>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row d-flex" v-else>
      <div class="col-md-8 mx-auto">
        <div class="jumbotron py-5 text-center">
          <strong class="display-6 text-danger">
            Access Denied <i class="fa fa-exclamation" aria-hidden="true"></i
          ></strong>
          <p class="lead text-muted py-4">
            Request For Permission From Administrator
          </p>
        </div>
      </div>
    </div>
  </Layout>
</template>
